import { z } from "zod";

// Validation schema
export const policyConfigSchema = z.object({
  version: z.string(),
  lastUpdated: z.string(),
  effectiveDate: z.string(),
  description: z.string(),
  bsdTiers: z.array(
    z.object({
      maxPrice: z.number(),
      rate: z.number(),
      baseAmount: z.number(),
    })
  ),
  absdRates: z.array(
    z.object({
      citizenship: z.string(),
      firstProperty: z.number().min(0).max(100),
      secondProperty: z.number().min(0).max(100),
      thirdPlusProperty: z.number().min(0).max(100),
    })
  ),
  housingLoanLTV: z.array(
    z.object({
      loanCount: z.string(),
      ltv: z.number().min(0).max(100),
    })
  ),
  ssdRates: z.object({
    before2025: z.array(
      z.object({
        minYears: z.number(),
        maxYears: z.number(),
        rate: z.number().min(0).max(100),
      })
    ),
    from2025: z.array(
      z.object({
        minYears: z.number(),
        maxYears: z.number(),
        rate: z.number().min(0).max(100),
      })
    ),
    commercialIndustrial: z.array(
      z.object({
        minYears: z.number(),
        maxYears: z.number(),
        rate: z.number().min(0).max(100),
      })
    ),
  }),
  effectiveDates: z.object({
    residential2025Change: z.string(),
  }),
  formLimits: z.object({
    interestRate: z.object({
      min: z.number(),
      max: z.number(),
      step: z.number(),
      default: z.number(),
    }),
    tenure: z.object({
      min: z.number(),
      max: z.number(),
      default: z.number(),
    }),
    propertyPrice: z.object({
      min: z.number(),
      default: z.number(),
    }),
  }),
});

export type FormData = z.infer<typeof policyConfigSchema>;